{
    "coordinates": [
        45.888794637449394,
        8.889514225976285
    ],
    "tooltip": "Besano",
    "title": "Besano Formation",
    "country": "Italy",
    "period": "Triassic",
    "alt": "TODO"
}
